var CouponCode = class extends HTMLElement {
  constructor() {
    super();
    this._applyCouponListener = this._applyCoupon.bind(this);
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.submitButton = this.querySelector('[type="submit"]');
    this.couponField = this.querySelector("input#coupon-code");
    this.submitButton.addEventListener("click", this._applyCouponListener);
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener("click", this._applyCouponListener);
  }
  async _applyCoupon(event) {
    event.preventDefault();
    this.submitButton.setAttribute("aria-busy", "true");

    // this.qu('#cart-accordion')

    // Redirect to the checkout page with the coupon code
    // window.location.href =
    //   "/discount/" + encodeURIComponent(this.couponField.value) + "%2Fcart";

    try {
      // Use Shopify's Admin or Storefront API to validate the coupon code.
      const response = await fetch(
        `https://app.tegelgalerie.nl/api/coupon/validate`,
        {
          method: "POST",
          body: JSON.stringify({ coupon: this.couponField.value }),
        }
      );
      const data = await response.json();

      console.log("data", data);

      // if (response.data.data.discountCodeByCode) {
      //   res.json({ valid: true });
      // } else {
      //   res.json({ valid: false });
      // }
    } catch (error) {
      res.json({ valid: false });
    }

    this.submitButton.setAttribute("aria-busy", "false");
  }
};

if (!window.customElements.get("coupon-code")) {
  window.customElements.define("coupon-code", CouponCode);
}
